jQuery(function($){
    $('.site-page-nav').on('mouseenter mouseleave', '.site-page-nav__item', function(e){
        if ('mouseenter' == e.type) $(this).removeClass('out').addClass('over');
        else $(this).removeClass('over').addClass('out');
        if ($(this).hasClass('active')) {
            $(this).removeClass('out');
        }
    });
    $('.site-page-nav__item.active').removeClass('out');
});
